import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './styles.scss';

const DeleteButton = ({ onClick }: { onClick: any }) => (
    <button className="field-delete-btn" type="button" onClick={() => onClick()}>
        <FontAwesomeIcon icon={['fal', 'trash-can']} className="button-container" />
    </button>
);

export default DeleteButton;
